document.addEventListener("DOMContentLoaded", function () {
  const headerContainer = document.querySelector(".header__container");
  if (!headerContainer) return;

  const topRightMenuWrapper = document.createElement("div");
  topRightMenuWrapper.className = "menu-top-right-flyout";
  topRightMenuWrapper.innerHTML = `
    <div class="menu-top-right-button"><a href="/pages/vernostni-sleva">Blauer Club</a></div>
    <div class="menu-top-right-button"><a href="/pages/blauer-dna">DNA</a></div>
    <div class="menu-top-right-button"><a href="/pages/kontakt">Kontakt</a></div>
    
  `;

  // Vložit vlevo do header containeru
  headerContainer.insertBefore(topRightMenuWrapper, headerContainer.firstChild);
});
